"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = RadioInputPropsCollector;

// Shell component for enhancing DX (developer experience)
function RadioInputPropsCollector() {
  return null;
}

RadioInputPropsCollector.displayName = "Radio.Input";
//# sourceMappingURL=RadioInputPropsCollector.js.map